import apiClient from "config/apiClient";
import { ChangelogType, PaginationParamType } from "type";
import { DEFAULT_LIMIT_ITEMS } from "constants/data";
import { getUserType } from "util/auth";

interface ResponseChangelogList {
  list: ChangelogType[];
  total: number;
}

/**
 * Get changelog list
 * @param body PaginationParamType
 */
const getChangelogApi = async (body: PaginationParamType = { limit: DEFAULT_LIMIT_ITEMS, offset: 1 }) => {
  const userType = getUserType();
  const params = {
    limit: body.limit,
    offset: body.offset,
    ...(userType && { sys_user_type: userType }),
  };

  const res = await apiClient.post<ResponseChangelogList>("/log/system/select", params);
  return {
    list: res.data?.list ?? [],
    total: res.data?.total ?? 0,
  };
};

export default getChangelogApi;
